import Builder from '@/components/base/Builder'

import { WPPageData } from '@/types'

type PageBuilderProps = {
  pageData: WPPageData
}

const PageBuilder = ({ pageData }: PageBuilderProps) => {
  return <Builder sections={pageData?.acf?.builder} />
}

export default PageBuilder
